// Real Bendito Tattoo logo (Aztec dog / Xoloitzcuintli).
// Source is a JPEG on a white background, so we present it on a cream "stamp"
// tile that matches the brand's warm secondary palette — looks like a pressed
// brand mark rather than an awkward floating cutout.
export const LOGO_URL = "/images/logo/logo.jpeg";

export const Logo = ({ size = 44, withWordmark = true }) => (
  <a
    href="#top"
    className="flex items-center gap-3 group select-none"
    data-testid="brand-logo-link"
    aria-label="Bendito Tattoo"
  >
    <span
      className="relative inline-flex items-center justify-center shrink-0 bg-[#F5F0EB] transition-transform duration-500 group-hover:-rotate-3 group-hover:scale-105 ring-1 ring-bendito-orange/30 group-hover:ring-bendito-orange/80"
      style={{ width: size, height: size }}
    >
      {/* Soft orange aura on hover */}
      <span
        className="absolute -inset-2 blur-xl opacity-0 group-hover:opacity-70 transition-opacity duration-500 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(224,112,32,0.6) 0%, rgba(224,112,32,0) 70%)",
        }}
      />
      <img
        src={LOGO_URL}
        alt="Bendito Tattoo"
        width={size}
        height={size}
        className="relative object-contain"
        style={{ width: "82%", height: "82%" }}
      />
    </span>
    {withWordmark && (
      <div className="leading-none">
        <div className="font-heading text-bendito-ink text-xl md:text-[22px] tracking-[0.22em]">
          BENDITO
        </div>
        <div className="font-mono text-[9px] tracking-[0.38em] text-bendito-orange uppercase mt-1">
          Tattoo · PDC
        </div>
      </div>
    )}
  </a>
);

export default Logo;
